import React from "react";
import {
  Grid,
  Button,
  Collapse,
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {
  AddRounded,
  RemoveRounded
} from "@mui/icons-material";
import {useSelector} from "react-redux";
import getTrans from "../../../../../languages/getTrans";

const FaqItems = () => {
  const classes = useStyles();
  const items = useSelector((state) => state.faq.items || []);
  return (
    <div className={classes.root}>
      <div className={classes.head}>
        <div className={classes.headIcon}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.75 9C21.75 8.60218 21.592 8.22064 21.3107 7.93934C21.0294 7.65804 20.6478 7.5 20.25 7.5H17.25V4.5C17.25 4.10218 17.092 3.72064 16.8107 3.43934C16.5294 3.15804 16.1478 3 15.75 3H3.75C3.35218 3 2.97064 3.15804 2.68934 3.43934C2.40804 3.72064 2.25 4.10218 2.25 4.5V16.5C2.25044 16.6411 2.29068 16.7792 2.36608 16.8985C2.44149 17.0177 2.54901 17.1133 2.67629 17.1742C2.80358 17.2351 2.94546 17.2589 3.08564 17.2428C3.22581 17.2266 3.3586 17.1713 3.46875 17.0831L6.75 14.4375V17.25C6.75 17.6478 6.90804 18.0294 7.18934 18.3107C7.47064 18.592 7.85218 18.75 8.25 18.75H17.0241L20.5312 21.5831C20.664 21.6905 20.8293 21.7493 21 21.75C21.1989 21.75 21.3897 21.671 21.5303 21.5303C21.671 21.3897 21.75 21.1989 21.75 21V9ZM17.7609 17.4169C17.6282 17.3095 17.4629 17.2507 17.2922 17.25H8.25V14.25H15.75C16.1478 14.25 16.5294 14.092 16.8107 13.8107C17.092 13.5294 17.25 13.1478 17.25 12.75V9H20.25V19.4297L17.7609 17.4169Z" fill="#FB7800"/>
          </svg>
        </div>
        <div className={classes.headTitle}>{getTrans('faqItems.Часто задаваемые вопросы')}</div>
      </div>
      <div className={classes.body}>
        <Grid container spacing={1}>
          {items.map((item, index) => (
            <Grid key={`FaqItemCard-${item.id}`} item xs={12}>
              <FaqItemCard item={item}/>
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  )
}
const FaqItemCard = ({item}) => {
  const classes = useStyles();

  const [isOpen, setOpen] = React.useState(false);
  const IconOpen = isOpen ? RemoveRounded : AddRounded;
  const handleChangeOpen = () => {
    setOpen(!isOpen);
  }

  return (
    <div className={classes.itemCard}>
      <Button className={classes.itemCardHead} onClick={handleChangeOpen}>
        <span dangerouslySetInnerHTML={{__html: item.question}}/>
        <IconOpen color="primary"/>
      </Button>
      <Collapse in={isOpen}>
        <div
          className={classes.itemCardBody}
          dangerouslySetInnerHTML={{__html: item.answer}}
        />
      </Collapse>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: "0 8px",
    boxSizing: "border-box",
  },

  head: {
    gap: "8px",
    display: "flex",
    marginBottom: "12px",
    alignItems: "center",
  },
  headIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24, height: 24,
  },
  headTitle: {
    fontSize: 18,
    fontWeight: "600",
    lineHeight: "24px",
    letterSpacing: "0.03em",
    color: theme.palette.text.primary,
  },

  body: {},

  itemCard: {
    borderRadius: "12px",
    background: "#FFFFFF0D",
    border: "1px solid #FFFFFF1A",
  },
  itemCardHead: {
    gap: "20px",
    width: "100%",
    padding: "8px 12px",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    justifyContent: "space-between",

    fontSize: 14,
    textAlign: "left",
    fontWeight: "400",
    lineHeight: "22px",
    letterSpacing: "0.03em",
    color: theme.palette.text.primary,
  },
  itemCardBody: {
    paddingTop: 0,
    padding: "8px 12px",
    boxSizing: "border-box",

    fontSize: 13,
    color: "rgba(255,255,255,0.5)",
    lineHeight: "16px",
    letterSpacing: "0.03em",

    "& a": {
      color: theme.palette.text.main,
    }
  },
}))

export default FaqItems;
